var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",function(){return [_c('button',{class:_vm.buttonClasses,on:{"click":_vm.login}},[_vm._v("\n      "+_vm._s(_vm.finalButtonLabel)+"\n      "),_c('LoadingIcon',{attrs:{"icon":_vm.buttonIcon,"loading":_vm.loading}})],1)]},{"login":_vm.login,"loading":_vm.loading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }